import React from 'react';
import './BlogsHeroArea.css';

const BlogsHeroArea = () => {
    return (
        <section className="blogsHero-section">
            <div className="blogs-bgOverlay">
                <div className="container">
                    <div className="blogs-hero-content">
                        <h4>Home / Blogs</h4>
                        <h1>Blogs</h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogsHeroArea;